<script>
//import { layoutComputed } from "@/state/helpers";
import Horizontal from "./horizontal";

export default {
  components: {
    Horizontal,
  },
  data() {
    return {};
  },
  computed: {
    //...layoutComputed,
  },
  mounted() {
    //document.body.classList.remove('authentication-bg')
  },
  methods: {
    
  },
};
</script>

<template>
  <div>
    <Horizontal>
      <slot />
    </Horizontal>
  </div>
</template>
